import MobileDescription from "./MobileDescription"
const MobileMain = () => {
    return (
        <>
            <MobileDescription/>
        </>
    )
}


export default MobileMain;